import { render } from "./collection-filter-item.vue?vue&type=template&id=609de60f&scoped=true"
import script from "./collection-filter-item.vue?vue&type=script&lang=js"
export * from "./collection-filter-item.vue?vue&type=script&lang=js"

import "./collection-filter-item.vue?vue&type=style&index=0&id=609de60f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609de60f"]])

export default __exports__